import React from 'react'
import HighlightOffOutlined from '@material-ui/icons/HighlightOffOutlined'

export default function HighlightOffOutlinedIcon(props) {
    const { ...other } = props

    return (
        <HighlightOffOutlined {...other} />
    )
}